import React from "react";
import { Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PaymentsIcon from "@mui/icons-material/Payments";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import CreditCardIcon from "@mui/icons-material/CreditCard";

const PaymentMethodDialog = ({ open, onClose, onSelect }) => {
  const handleSelection = (method) => {
    onSelect(method);
    onClose();
  };

  const methods = [
    {
      id: "เงินสด",
      label: "เงินสด",
      icon: <PaymentsIcon sx={{ fontSize: 48 }} />,
      color: "text-emerald-600",
      bg: "bg-emerald-50",
      hover: "hover:bg-emerald-100",
      border: "border-emerald-200",
    },
    {
      id: "โอนเงิน",
      label: "โอนเงิน",
      icon: <QrCode2Icon sx={{ fontSize: 48 }} />,
      color: "text-blue-600",
      bg: "bg-blue-50",
      hover: "hover:bg-blue-100",
      border: "border-blue-200",
    },
    {
      id: "ATM",
      label: "ATM",
      icon: <CreditCardIcon sx={{ fontSize: 48 }} />,
      color: "text-orange-600",
      bg: "bg-orange-50",
      hover: "hover:bg-orange-100",
      border: "border-orange-200",
    },
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: { borderRadius: "24px", padding: "16px" }, // Tailwind rounded-3xl equivalent
        className: "shadow-2xl",
      }}
    >
      {/* Header */}
      <div className="relative px-6 pt-4 pb-2 text-center">
        <h2 className="text-2xl font-bold text-slate-800">
          เลือกวิธีการชำระเงิน
        </h2>
        <p className="text-slate-500 mt-1 text-sm">
          เลือกช่องทางที่ลูกค้าต้องการชำระเงินเพื่อดำเนินการต่อ
        </p>
        <IconButton
          onClick={onClose}
          className="absolute right-0 top-0 text-slate-400 hover:text-slate-600"
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </div>

      {/* Content */}
      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {methods.map((item) => (
            <button
              key={item.id}
              onClick={() => handleSelection(item.id)}
              className={`
                group relative flex flex-col items-center justify-center p-8 
                rounded-2xl border-2 transition-all duration-300 ease-in-out
                ${item.bg} ${item.border} ${item.hover}
                hover:shadow-lg hover:-translate-y-1 focus:outline-none focus:ring-4 focus:ring-offset-2
                ${item.id === "เงินสด" ? "focus:ring-emerald-200" : ""}
                ${item.id === "โอนเงิน" ? "focus:ring-blue-200" : ""}
                ${item.id === "ATM" ? "focus:ring-orange-200" : ""}
              `}
            >
              <div
                className={`mb-4 p-4 rounded-full bg-white shadow-sm ${item.color}`}
              >
                {item.icon}
              </div>
              <span className={`text-xl font-bold ${item.color}`}>
                {item.label}
              </span>
              <span className="text-slate-500 text-sm mt-2 opacity-80 group-hover:opacity-100">
                {item.desc}
              </span>
            </button>
          ))}
        </div>
      </div>
    </Dialog>
  );
};

export default PaymentMethodDialog;
